export default "__VITE_ASSET__nF6f1pto__"